import { apiClient } from "../../../../lib/axios";
import type {
  ChatbotQueryRequest,
  ChatbotQueryResponse,
  StandardInsightsQueryParams,
  StandardInsightsResponse,
  ComparisonSummaryRequest,
  ComparisonSummaryResponse,
} from "./types";

export const insightsApi = {
  queryChatbot: async (
    payload: ChatbotQueryRequest
  ): Promise<ChatbotQueryResponse> => {
    const response = await apiClient.post("/admin/insights/query", payload, {
      timeout: 60000,
    });
    return response.data;
  },

  getStandardInsights: async (
    params: StandardInsightsQueryParams
  ): Promise<StandardInsightsResponse> => {
    const response = await apiClient.get("/admin/insights/standard", {
      params,
      timeout: 60000,
    });
    return response.data;
  },

  getComparisonSummary: async (
    payload: ComparisonSummaryRequest
  ): Promise<ComparisonSummaryResponse> => {
    const response = await apiClient.post(
      "/admin/insights/comparison-summary",
      payload,
      { timeout: 60000 }
    );
    return response.data;
  },
};
